module.exports = "https://dev.stanwinstonschool.com/jurassic.7d8820116da99a1f0d9473e3fabff001.jpg";